import { configureStore } from '@reduxjs/toolkit'
import coursesReducer from './courses'
import examsReducer from './exams'
import questionsReducer from './questions'
import UsersReducer from './users'
import guestsReducer from './guests'
import worksheetsReducer from './worksheets'
import dashboardReducer from './dashboard'

const reducer = {
  exams: examsReducer,
  courses: coursesReducer,
  questions: questionsReducer,
  users: UsersReducer,
  guests: guestsReducer,
  worksheets: worksheetsReducer,
  dashboard: dashboardReducer,
}

export const store = configureStore({
  reducer: reducer
})
